module.exports = function(pages) {
	"use strict";
  pages
  .controller('allpagesController', allpagesController);
	allpagesController.$inject = ["watchAllCheckboxesNgTable","$timeout","$state","$stateParams","API_URL","$scope","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","putDataService","alertService","$http","postDataService","serverError","offlineError"];
	
  function allpagesController(watchAllCheckboxesNgTable,$timeout,$state,$stateParams,API_URL,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,putDataService, alertService, $http,postDataService,serverError,offlineError) {
    var vmapg = this;
    vmapg.editPostShow = false;
    $rootScope.emptyTable = false;
    var state = 'pages';
    vmapg.status = 'publish';
    var status = vmapg.status;
    var page = 1;
    var author;
    var date_start;
    var date_end;
    var sortby ='date';
    var s;
    var $data;
    vmapg.reverse = false;
    vmapg.selectedTitle = -1;
    vmapg.selectedAuthor = -1;
    vmapg.selectedTags = -1;
    vmapg.editCategoryShow = false;
    vmapg.loadCategory = false;
    vmapg.selectedBulkAction = {value: 'default'};
    vmapg.checkedPostsforUpdate = [];
    vmapg.checkedPostsEdit = [];
    vmapg.checkboxes = { 'checked': false, items: {} };
    vmapg.statusTrash = false;
    vmapg.post_id = $stateParams.id;
    if($stateParams.id) {
      vmapg.editPostShow = true;
    } else {
      vmapg.editPostShow = false;
    }
    $scope.ranges = {
      'Today': [moment().startOf('day'), moment()],
      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
      'Last 7 days': [moment().subtract('days', 7), moment()],
      'Last 30 days': [moment().subtract('days', 30), moment()],
      'This month': [moment().startOf('month'), moment().endOf('month')],
      'All days':[moment().subtract('year',5),moment()]
    };
    vmapg.editPost = function(postId) {
      vmapg.editPostShow = true;
      jQuery("html, body").animate({
        scrollTop: 0
      }, 600);
      vmapg.post_id = postId;
      $state.transitionTo('app.allpages', {id: vmapg.post_id}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    var arrayPostsIdFunction = function() {
      if (vmapg.checkedPostsEdit.length>0 ) {
        for(var i=0;i<vmapg.checkedPostsEdit.length;i++) {
          vmapg.checkedPostsforUpdate.push(vmapg.checkedPostsEdit[i]);
        }
      }
    }
    var putPostsFunction = function(url, status) {
      var postsStatus = status;
      var updateDataPosts = {
        "ids": vmapg.checkedPostsforUpdate,
        "status": postsStatus,
      }
      var putFunction = function() {   
        $http.put(url , updateDataPosts)
        .success(function (data, status, headers) {
            alertService('success','Success ', data.message, 2000);
            vmapg.tableParams.reload();
            vmapg.checkedPostsforUpdate = [];
            vmapg.checkedPostsEdit = [];
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                   putFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else if(status ==502) {
            serverError()
          } else{  
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
          }
          vmapg.checkedPostsforUpdate = [];
          vmapg.checkedPostsEdit = [];
        });
      }
      putFunction();
    }
    vmapg.updateStatusPost = function(post_id, status) {
      vmapg.checkedPostsforUpdate = [];
      putPostsFunction(API_URL + 'pages', status);
      vmapg.checkedPostsforUpdate.push(post_id);
    }
    vmapg.deletePostsFunction = function(data) {
      var postFunction = function() { 
        postDataService.save({
          param1:state,
          param2:'bulk',
          param3:'delete' 
        },{
          'ids':vmapg.checkedPostsforUpdate
        }).$promise.then(function(postData){
          alertService('success','Success ', postData.message, 2000);
          vmapg.tableParams.reload();
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  postFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
        });
      }
      postFunction();
    }
    vmapg.deletePosts = function(post_id) {
      vmapg.checkedPostsforUpdate = [];
      vmapg.checkedPostsforUpdate.push(post_id)
      vmapg.deletePostsFunction();  
    }
    vmapg.bulkAction = function(status) {
      vmapg.checkedPostsforUpdate = [];
      
      if(status != "delete" && vmapg.checkedPostsEdit.length > 0) {
        arrayPostsIdFunction();
        putPostsFunction(API_URL + 'pages', status);
        watchAllCheckboxesNgTable.resetCheckBox(vmapg)
        vmapg.tableParams.reload();
      } else if (status == 'delete' && vmapg.checkedPostsEdit.length>0 ) {
        vmapg.hiddenBulkEdit =true;
        arrayPostsIdFunction();
        vmapg.deletePostsFunction();
      } 
    }
    watchAllCheckboxesNgTable.watch($scope, vmapg)
    vmapg.checkedPost = function(categoryId, checked) {
      if(checked) {
        vmapg.checkedPostsEdit.push(categoryId);
      } else {

        if(vmapg.checkedPostsEdit.includes(categoryId)) {
          var id_tag = categoryId;
          var position = vmapg.checkedPostsEdit.indexOf(id_tag);
          vmapg.checkedPostsEdit.splice(position, 1);
        }
      }
    }
    vmapg.changeSearch = function(search_data) {
      if(search_data) {
        s = search_data;
      } else {
        s = null;
        $timeout(function() {
            vmapg.search();
          },0)             
      }
    }
    vmapg.changeDate = function(value) {
      vmapg.dateRangevalue = value;
      if(vmapg.dateRangevalue) {
        if(value.startDate && value.endDate) {
          date_start = value.startDate.format('YYYY-MM-DD');
          date_end = value.endDate.format('YYYY-MM-DD');
        } else {
          date_start = null;
          date_end = null;
        }
      } else {
        date_start = null;
        date_end = null;
      }
    }
    vmapg.pageFilter = function() {
      reloadTableFunction();
    }
    vmapg.resetAllFilters = function() {
      vmapg.status = 'publish';
      status = 'publish';
      author = null;
      vmapg.searchData = null;
      s =null;
      date_start = null;
      date_end = null;
      $scope.$broadcast('clear-daterange',true);
      reloadTableFunction();
    }
    vmapg.authorPosts = function(value) {
      author = value;
      reloadTableFunction();
    }
    vmapg.changeStatus =function(event,activeStatus) {
      vmapg.status = activeStatus;
      status = vmapg.status
      if(activeStatus == 'all') {
        status = null;
      } else {
        status = activeStatus;
      }
      if(activeStatus == 'trash') {
        vmapg.statusTrash = true;
      } else {
        vmapg.statusTrash = false;
      }
      reloadTableFunction();
    }
    vmapg.search =function(value) {
      if(value) {
        s = value.toLowerCase();
      } else {
        s = null;
      }
      reloadTableFunction();
    }
    function reloadTableFunction() {
      if(vmapg.tableParams.page() ==1) {
        vmapg.tableParams.reload();
      } else {
        vmapg.tableParams.page(1);
      }
    } 
    vmapg.tableReloadFunction = function(page) {
      vmapg.tableParams = new NgTableParams({
          page: page || 1,
          count: 20,
          
      }, {
        getData: function(params) {
          $rootScope.hasLoaded = false;
          return getDataService.get({
            param1: state,
            param2: null,
            status: status,
            page: params.page(),
            limit: params.count(),
            author: author,
            s:s,
            sortby: $rootScope.sortby,
            sort : $rootScope.sort,
            date_start: date_start,
            date_end: date_end
            }).$promise.then(function(data){
            $rootScope.hasLoaded = true;
            $data =data.pages; 
            vmapg.dataGet = data.pages;
            if(data.pages.length == 0) {
              $rootScope.emptyTable = true;
            } else {
              $rootScope.emptyTable = false;
            } 
            params.total(data.count);
            params.numPages(data.max_pages);
            jQuery('.goTo input').val("");
            watchAllCheckboxesNgTable.resetCheckBox(vmapg)
            vmapg.checkedPostsforUpdate = [];
            vmapg.selectedBulkAction = {value: 'default'};
            return $data;
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError('refresh')
              $rootScope.hasLoaded = true;
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) { 
                  if(answer==200) {
                    vmapg.tableReloadFunction(params.page());
                  }
                  // do something
                },
                function(error) {
                },
                function(progress) {
                 // report progress
                });
            } else if(error.status ==404) {
              $rootScope.emptyTable = true;
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.'); 
            }
            $rootScope.hasLoaded = true;
          });
        }    
      });
    }
    vmapg.tableReloadFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/pagesModule/allpages/js/allpagesController.js
// module id = 535
// module chunks = 0